import { Slide, toast } from "react-toastify";

const createToast = (title, body, severity, path, navigate) => {
  const toastContent = (
    <div>
      <div style={{ fontSize: "16px", fontWeight: "bold" }}>{title}</div>
      <div style={{ fontSize: "14px", marginTop: "5px" }}>{body}</div>
    </div>
  );

  const toastConfig = {
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    autoClose: false,
    transition: Slide,
    onClick: () => {
      if (typeof path === "string" && !path.includes("null")) {
        navigate(path);
      }
    },
  };

  switch (severity) {
    case "critical":
      return toast.error(toastContent, toastConfig);
    case "warning":
      return toast.warning(toastContent, toastConfig);
    case "success":
      return toast.success(toastContent, toastConfig);
    case "info":
    default:
      return toast.info(toastContent, toastConfig);
  }
};

const displayNotification = (payload, navigate) => {
  const { title = null, body = null } = payload.notification || {};
  const {
    module = null,
    type = null,
    severity = null,
    id = null,
  } = payload.data || {};

  const path = () => {
    // Casos de navegación según el módulo al que corresponde la notificación
    switch (module) {
      case "user-request-management":
        let auxType =
          type === "urgency" || type === "express_urgency"
            ? "urgency"
            : "reservation";
        return !isNaN(id)
          ? `/${module}/${auxType}/${id}`
          : `/${module}/${auxType}`;
      case "users-management":
        return !isNaN(id) ? `/${module}/${type}/${id}` : `/${module}/${type}`;
      case "route-tracking":
        // ||| Agregar query params con los datos de la ruta( enviarlas en el objeto data de la notificación ) para definir el center por defecto en el mapa
        return `/${module}/${id}`;
      default:
        // Incluir el ID solo si es un número
        return !isNaN(id) ? `/${module}/${id}` : `/${module}`;
    }
  };

  // Crear el toast
  createToast(title, body, severity, path(), navigate);
};

export default displayNotification;
